const TEMPLATE = `
<section class="benefits-section container-fluid fade-up">
    <div class="row">
        <div class="col-md-6">
            <p class="section-label" data-animate-child>Переваги партнерства</p>
        </div>
        <div class="col-md-6">
            <h3 data-animate-child>
                Чому варто співпрацювати з BML?
            </h3>
            <p data-animate-child>Ми надаємо більше, ніж просто результати досліджень — ми забезпечуємо точність,
                швидкість і експертну підтримку на кожному етапі.</p>
        </div>
    </div>

    <div class="row benefits-row">
        <div class="col-md-3 advantage-right-pd">
            <div class="advantage-card">
                <div class="card-front">
                    <img src="/images/icon-benefit-1.png" alt="Персоналізовані інсайти" class="icon-circle">
                    <h4>ПЕРСОНАЛІЗОВАНІ ІНСАЙТИ</h4>
                </div>
                <div class="card-back">
                    <p>Лабораторія BML продовжує традиції професійної династії Богомольців, яка налічує шість поколінь медиків. Досвід у сфері патофізіології та патоморфології гарантує високі стандарти сучасної діагностики та достовірність результатів досліджень.</p>
                </div>
            </div>
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-3 advantage-right-pd">
            <div class="advantage-card">
                <div class="card-front">
                    <img src="/images/icon-benefit-2.png" alt="Експертна валідація" class="icon-circle">
                    <h4>ЕКСПЕРТНА ВАЛІДАЦІЯ</h4>
                </div>
                <div class="card-back">
                    <p>Система контролю якості охоплює всі етапи діагностичного процесу — від прийому біоматеріалу до фінального висновку. Компетентність лабораторії підтверджена міжнародними стандартами ISO 15189:2022 та ISO 9001:2015.</p>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="advantage-card">
                <div class="card-front">
                    <img src="/images/icon-benefit-3.png" alt="Швидка логістика" class="icon-circle">
                    <h4>ШВИДКА ЛОГІСТИКА</h4>
                </div>
                <div class="card-back">
                    <p>Ми виконуємо дослідження в строк до 5 робочих днів, а у невідкладних випадках — до 48 годин. На будь-яке звернення реагуємо максимально швидко — протягом 15 хвилин.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="row benefits-row">
        <div class="col-md-3"></div>
        <div class="col-md-3 advantage-right-pd">
            <div class="advantage-card">
                <div class="card-front">
                    <img src="/images/icon-benefit-4.png" alt="Цифрова точність" class="icon-circle">
                    <h4>ЦИФРОВА ТОЧНІСТЬ</h4>
                </div>
                <div class="card-back">
                    <p>В структурі лабораторії працює DERMPATHLab — перша в Україні спеціалізована цифрова лабораторія дерматопатології. Наші патоморфологи мають визнану експертизу в гістологічній та імуногістохімічній діагностиці.</p>
                </div>
            </div>
        </div>
        <div class="col-md-3 advantage-right-pd">
            <div class="advantage-card">
                <div class="card-front">
                    <img src="/images/icon-benefit-5.png" alt="Комплексне тестування" class="icon-circle">
                    <h4>КОМПЛЕКСНЕ ТЕСТУВАННЯ</h4>
                </div>
                <div class="card-back">
                    <p>Лабораторія бере участь у міжнародних програмах зовнішньої оцінки якості та міжлабораторних порівнянь. Це дозволяє підтверджувати діагностичну точність, підтримувати високий рівень компетентності команди та відповідати міжнародним професійним стандартам.</p>
                </div>
            </div>
        </div>
        <div class="col-md-3"></div>
    </div>
</section>
`;

class BmlExpertiseBenefits extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-expertise-benefits', BmlExpertiseBenefits);
